import { SECCIONES_B2C_PEDIDOS, SECCIONES_B2B_PEDIDOS, SECCIONES_B2C_PRODUCTOS } from "./ConsultReportHelpers";

export const REPORT_CONFIG = {
    B2C_PEDIDOS: {
        label: "B2C - Pedidos",
        titulo: "Reporte de pedidos",
        tipo: "pedido",
        tab: {
            primary: "ORDER_ID",
            secondary: "CIUDAD",
        },
        header: {
            titlePrefix: "Orden",
            id: "ORDER_ID",
            sub: [
                { field: "FECHA_PEDIDO", type: "fecha" },
                { text: " · " },
                { field: "TIENDA" },
            ],
            groups: [
                { label: "Estado e-commerce", field: "ESTADO", status: true },
                { label: "Estado entrega", field: "ESTADO_ENTREGA", status: true },
                { label: "Entrega prometida", field: "FECHA_PROMESA_ENTREGA", type: "rango" },
            ],
            total: {
                label: "Valor recaudado",
                field: "VALOR_RECAUDADO",
                type: "dinero",
            },
        },
        secciones: SECCIONES_B2C_PEDIDOS,
    },

    B2B_PEDIDOS: {
        label: "B2B - Pedidos",
        titulo: "Reporte de pedidos",
        tipo: "pedido",
        tab: {
            primary: "PEDIDO_SAP",
            secondary: "CIUDAD",
        },
        header: {
            titlePrefix: "Pedido SAP",
            id: "PEDIDO_SAP",
            sub: [
                { field: "FECHA_PEDIDO", type: "fecha" },
                { text: " · " },
                { field: "TIENDA" },
            ],
            groups: [
                { label: "Estado e-commerce", field: "ESTADO_COMMERCE", status: true },
                { label: "Estado entrega", field: "ESTADO_ENTREGA", status: true },
                { label: "Entrega estimada", field: "FECHA_ESTIMADA_ENTREGA", type: "fecha" },
            ],
            total: {
                label: "Valor recaudado",
                field: "VALOR_RECAUDADO",
                type: "dinero",
            },
        },
        secciones: SECCIONES_B2B_PEDIDOS,
    },

    B2C_PRODUCTOS: {
        label: "B2C - Productos",
        titulo: "Reporte de productos",
        tipo: "producto",
        tab: {
            primary: "SKU",
            secondary: "NOMBRE_EQUIPO",
        },
        header: {
            titlePrefix: "Producto",
            id: "SKU",
            sub: [
                { field: "NOMBRE_EQUIPO" },
            ],
            groups: [
                { label: "Estado", field: "ESTADO", status: true },
                { label: "Categoría", field: "CATEGORIA" },
                { label: "Subcategoría", field: "SUBCATEGORIA" },
                { label: "Stock disponible", field: "STOCK_DISPONIBLE" },
            ],
            total: {
                label: "Precio oferta",
                field: "PRECIO_OFERTA",
                type: "dinero",
            },
        },
        secciones: SECCIONES_B2C_PRODUCTOS,
    },
};

export const REPORT_OPTIONS = Object.entries(REPORT_CONFIG).map(([value, config]) => ({
    value,
    label: config.label,
}));
